import React, { useState } from "react";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import styles from "./StatusDropdown.module.scss";
import MenuIcon from "../../../assets/images/menu-icon.svg";
import PendingIcon from "../../../assets/images/status-icons/pending-status-icon.svg";
import CancelledIcon from "../../../assets/images/status-icons/cancelled-status-icon.svg";
import ApprovedIcon from "../../../assets/images/status-icons/approved-status-icon.svg";
import Proptypes from "prop-types";
import { updateBrandStatus } from "../../../helpers/service";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { setBrands } from "../../Redux/Reducer/appReducer";

const StatusDropdown = ({
  customMenuObject,
  currentStatus,
  brandId,
  onComplete,
  setLoading,
}) => {
  const dispatch = useDispatch();
  const brandData = useSelector((state) => state?.appReducer)?.brands;
  const [statusDropdown, setStatusDropdown] = useState(false);

  const toggle = () => setStatusDropdown(!statusDropdown);

  const handleChangeStatus = async (newStatus) => {
    if (currentStatus?.toLowerCase() === newStatus?.toLowerCase()) {
      toast.warning(
        "Brand is already set in this status, please select something else"
      );
      return;
    } else {
      try {
        setLoading(true);
        await updateBrandStatus({
          id: brandId,
          newStatus,
        });
        const newBrands = (brandData || [])?.map((brand) => {
          if (brand?.id === brandId) {
            return {
              ...brand,
              status: newStatus,
            };
          } else {
            return brand;
          }
        });
        setLoading(false);
        dispatch(setBrands(newBrands));

        onComplete && onComplete(newStatus);
        toggle();
        toast.success("Status updated successfully");
      } catch (err) {
        setLoading(false);
        toggle();
        toast.error("Something went wrong");
      }
    }
  };
  return (
    <div className={styles["dropdown_container"]}>
      <Dropdown isOpen={statusDropdown} toggle={toggle}>
        <DropdownToggle className={styles["dropdown_toggle"]}>
          <img
            src={customMenuObject?.icon ? customMenuObject?.icon : MenuIcon}
            width={customMenuObject?.width ? customMenuObject?.width : 3}
            height={customMenuObject?.height ? customMenuObject?.height : 14}
            alt="menu"
          />
        </DropdownToggle>
        <DropdownMenu className={styles["dropdown_status_menu"]}>
          <DropdownItem
            className={styles["status_item"]}
            onClick={() => {
              handleChangeStatus("pending");
            }}
          >
            <img src={PendingIcon} width={24} height={24} alt="icon" />{" "}
            <div
              style={{
                color: "#7167e9",
              }}
            >
              Set to pending
            </div>
          </DropdownItem>
          <DropdownItem
            className={styles["status_item"]}
            onClick={() => {
              handleChangeStatus("cancel");
            }}
          >
            <img src={CancelledIcon} width={24} height={24} alt="icon" />{" "}
            <div
              style={{
                color: "#f00",
              }}
            >
              Cancel
            </div>
          </DropdownItem>
          <DropdownItem
            className={styles["status_item"]}
            onClick={() => {
              handleChangeStatus("approve");
            }}
          >
            <img src={ApprovedIcon} width={24} height={24} alt="icon" />{" "}
            <div
              style={{
                color: "#00b533",
              }}
            >
              Approve
            </div>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
  );
};

StatusDropdown.propTypes = {
  customMenuObject: Proptypes.object,
  currentStatus: Proptypes.string,
  brandId: Proptypes.number,
  onComplete: Proptypes.func,
};

export default StatusDropdown;
